import { type Association, type Opportunity } from "@entities";
import { type ColumnProps } from "@shared/frontend/hyper-table/types";
import { type CoreRow } from "@tanstack/react-table";
import PhoneNumberCell from "../PhoneNumberCell";
import { formatDaysSchedule } from "../association-requested-table/columns";
import {
  formatOpportunityEndDisplay,
  formatOpportunityStartDisplay,
  formatOpportunitySchedule,
} from "@shared/helpers/format-opportunity-schedule";
import UserNameAndPhoto from "../users-table/volunteers/components/UserNameAndPhoto";
import { partnerOrganizationTableColumn } from "../../../components/partner-organization-select/OpportunityPartnerOrganizationCell";

export const AidRelatedColumns: ColumnProps<Association>[] = [
  {
    field: "user.name",
    cell: ({ row }) => <UserNameAndPhoto user={row.original.user} />,
  },
  {
    field: "user.phoneNumber",
    cell: ({ row }: { row: CoreRow<Association> }) => (
      <PhoneNumberCell phoneNumber={row.original.user?.phoneNumber || ""} />
    ),
    enableSorting: false,
  },
  {
    field: "user.address",
    enableSorting: false,
    cell: ({ row }: { row: CoreRow<Association> }) => (
      <span title={row.original.user?.address}>
        {row.original.user?.address}
      </span>
    ),
  },
  {
    field: "user.gender",
    enableSorting: false,
    // Cell: ({ row }: { row: CoreRow<Association> }) => (
    //   <span title={row.original.user?.gender}>
    //     {row.original.user?.gender}
    //   </span>
    // ),
  },
  {
    field: "user.dateOfBirth",
    enableSorting: false,
    // Cell: ({ row }: { row: CoreRow<Association> }) => (
    //   <span title={row.original.user?.address}>
    //     {row.original.user?.address}
    //   </span>
    // ),
  },
  {
    field: "requestedOpportunitiesCount",
  },
];

export const associationRequestedColumns: ColumnProps<Opportunity>[] = [
  {
    field: "title",
    enableSorting: true,
  },
  { field: "location" },
  {
    field: "status",
    caption: "סוג",
    valueConverter: (row: Opportunity) => {
      return row.status === "AID_REQUEST" ? "בקשת סיוע" : "משימה";
    },
  },
  partnerOrganizationTableColumn,
  {
    field: "userRequestedAvailabilityTime.dow",
    caption: "זמינות/תאריך",
    cell: ({ row }: { row: CoreRow<Opportunity> }) => {
      const value = !row.original.userRequestedAvailabilityTime
        ? formatOpportunitySchedule(row.original)
        : formatDaysSchedule(row.original.userRequestedAvailabilityTime);
      return <span title={value}>{value}</span>;
    },
  },
  {
    field: "startDate",
    cell: ({ row }: { row: CoreRow<Opportunity> }) => (
      <span title={formatOpportunityStartDisplay(row.original)}>
        {formatOpportunityStartDisplay(row.original)}
      </span>
    ),
  },
  {
    field: "endDate",
    cell: ({ row }: { row: CoreRow<Opportunity> }) => (
      <span title={formatOpportunityEndDisplay(row.original)}>
        {formatOpportunityEndDisplay(row.original)}
      </span>
    ),
  },
  {
    field: "createdAt",
    cell: ({ row }: { row: CoreRow<Opportunity> }) => {
      return row.original.createdAt
        ? new Date(row.original.createdAt).toLocaleString("he", {
          hour: "2-digit",
          minute: "2-digit",
          year: "numeric",
          month: "2-digit",
          day: "2-digit",
        })
        : " - ";
    },
    enableSorting: true,
  },
];
